import {Component, computed, effect, input, signal, Signal, ChangeDetectionStrategy} from '@angular/core';
import {ProgressBarComponent} from "../progress-bar/progress-bar.component";
import {FlexModule} from "@ngbracket/ngx-layout";

@Component({
  selector: 'app-lib-dimmer',
  imports: [
    ProgressBarComponent,
    FlexModule
  ],
  templateUrl: './dimmer.component.html',
  styleUrl: './dimmer.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DimmerComponent {

  fullscreen = input<boolean>(false);
  dimmed = input<boolean>(false);
  title = input<string|undefined>('');
  message = input<string|undefined>('');
  showProgress = input<boolean>(true);
  dimLevel = input<number>(0.9);
  position = input<'top'|'bottom'|'center'>('center');

  fxLayoutAlign = computed(() => {
    if (this.position() === 'top') {
      return 'center start';
    } else if (this.position() === 'bottom') {
      return 'center end';
    }
    return 'center center';
  });

  protected opacity = computed(() => {
    return this.dimLevel() * 100;
  });

}


export function debouncedSignal<T>(
  sourceSignal: Signal<T>,
  debounceTimeInMs = 0
): Signal<T> {
  const debounceSignal = signal(sourceSignal());
  effect(
    (onCleanup) => {
      const value = sourceSignal();
      const timeout = setTimeout(
        () => debounceSignal.set(value),
        debounceTimeInMs
      );

      // The `onCleanup` argument is a function which is called when the effect
      // runs again (and when it is destroyed).
      // By clearing the timeout here we achieve proper debouncing.
      // See https://angular.io/guide/signals#effect-cleanup-functions
      onCleanup(() => clearTimeout(timeout));
    }
  );
  return debounceSignal;
}
